class Mergeable {
  shouldMerge(other) {
    if (!other) {
      return false;
    }

    // If they are the same object then there is no point in merging
    if (this === other) {
      return false;
    }

    return true;
  }

  merge() {
    throw new Error('Must be overridden');
  }
}

export default Mergeable;
